(function() {
  var mapEl = document.querySelector('[data-service-area-map]');
  if (!mapEl) return;

  var LAT = parseFloat(mapEl.dataset.lat);
  var LNG = parseFloat(mapEl.dataset.lng);
  var RADIUS = parseFloat(mapEl.dataset.radius);
  var LABEL = mapEl.dataset.radiusLabel;
  var SHOW_MARKER = mapEl.dataset.showMarker !== 'false';
  var BUSINESS_NAME = mapEl.dataset.businessName;
  var PULSE_METERS = parseFloat(mapEl.dataset.pulseMeters);

  function initMap() {
    var center = { lat: LAT, lng: LNG };

    var map = new google.maps.Map(mapEl, {
      center: center,
      zoom: 9,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative'
    });

    if (SHOW_MARKER) {
      var marker = new google.maps.Marker({
        map: map,
        position: center,
        title: BUSINESS_NAME
      });

      var infoWindow = new google.maps.InfoWindow({
        content: '<div style="font-family:system-ui,sans-serif;padding:4px 0">'
          + '<strong style="font-size:14px">' + BUSINESS_NAME + '</strong><br>'
          + '<span style="font-size:12px;color:#475569">' + LABEL + '</span>'
          + '</div>'
      });
      marker.addListener('click', function() { infoWindow.open(map, marker); });
    }

    var circle = new google.maps.Circle({
      map: map,
      center: center,
      radius: RADIUS,
      fillColor: '#2563EB',
      fillOpacity: 0.08,
      strokeColor: '#2563EB',
      strokeOpacity: 0.6,
      strokeWeight: 2
    });
    if (SHOW_MARKER && typeof marker !== 'undefined') {
      circle.bindTo('center', marker, 'position');
    }

    map.fitBounds(circle.getBounds());

    /* Breathing animation — pulse opacity + radius */
    if (PULSE_METERS > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var start = null;
      function breathe(ts) {
        if (!start) start = ts;
        var t = ((ts - start) % 4000) / 4000;
        var s = 0.5 + 0.5 * Math.sin(t * Math.PI * 2);
        circle.setOptions({
          fillOpacity: 0.04 + 0.08 * s,
          strokeOpacity: 0.4 + 0.3 * s,
          radius: RADIUS + PULSE_METERS * s
        });
        requestAnimationFrame(breathe);
      }
      requestAnimationFrame(breathe);
    }
  }

  /* Load Maps JS API (or run immediately if already loaded) */
  /* Derive a unique callback name from the element's id to avoid collisions */
  var cb = 'initSAM_' + mapEl.id.replace(/-/g, '_');
  window[cb] = initMap;

  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    initMap();
  } else {
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapEl.dataset.mapsKey) + '&callback=' + cb;
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }
})();
